import React, { useState, useEffect } from 'react';
import * as api from '../../api';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Spinner from '../../Plateforme/Atoms/Spinner';
import Section from '../Atoms/Section';
import { useSearchParams } from 'react-router-dom';
import { generateFD100KVDataURL, generateGenericFD100KVDataURL, generateGenericFD100KVClassicDataURL } from '../Utils/generateFD100KV';
import { supabase } from '../../lib/supabaseClient';
import FD100KitPage from './FD100KitPage';

const Container = styled.div`
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
`;

const ErrorMessage = styled.div`
    text-align: center;
    padding: 60px 20px;
    color: #dc3545;

    .icon {
        font-size: 64px;
        margin-bottom: 16px;
    }

    .title {
        font-size: 24px;
        font-weight: bold;
        margin-bottom: 8px;
    }

    .message {
        font-size: 16px;
        color: #666;
    }
`;

// List of winner project IDs from FD10025Winners.js
const WINNER_PROJECT_IDS = [
    '67a332e21b103d938bafb0dc', '67a0b8331b103d938bafa954', '67aa1011740d844a3d633e93',
    '6829daa5754f51df2ef9141c', '67e6c18043d5609350e381a8', '67b5e6146890f1a147192905',
    '67be4a58b1ba28c3144aeb73', '67bf2330b1ba28c3144af8d2', '67c090dcdb48cb16a13c5b43',
    '677268097ec5d90c89d6fe63', '67c6b416db48cb16a13c73c7', '67ab652c07736060460b3b75',
    '68348986754f51df2ef9b87c', '67d15108d95ccf24eaf191df', '67d7d38c43d5609350e242a1',
    '67d82d2243d5609350e24c5e', '662adc507159e5b1b1da7c75', '67d8718c43d5609350e25c38',
    '67d1977243d5609350e218f2', '682b5c5f754f51df2ef93bbc', '67da910a43d5609350e274d7',
    '67e1864b43d5609350e2baeb', '67daebf343d5609350e27a9e', '67dd585043d5609350e28e57',
    '67dfeb0e43d5609350e2a360', '67e1452a43d5609350e2b066', '678675e2de3ed4a7001ab532',
    '67e2d05943d5609350e2cf97', '67e3e1cb43d5609350e304e5', '67e3e81543d5609350e308de',
    '67e3f02643d5609350e30a0a', '67e42d7043d5609350e32539', '67e42e5543d5609350e32570',
    '67e45c9843d5609350e329c0', '67e529f743d5609350e33a8c', '67e53aab43d5609350e340c3',
    '67e56ab043d5609350e3490f', '67e5764d43d5609350e34cb5', '67e57f5143d5609350e3519a',
    '67e5864c43d5609350e353a3', '67e58da443d5609350e3561d', '67e58ebc43d5609350e35665',
    '67e5ab6b43d5609350e35905', '67e6828d43d5609350e36b6a', '67e6acaf43d5609350e37832',
    '67e51ddb43d5609350e33667', '67e6c0a843d5609350e380cf', '67e6d53a43d5609350e38725',
    '67e6dfff43d5609350e38900', '67e7003c43d5609350e38bfc', '6834625c754f51df2ef9a4b1',
    '67ea99b76b7945ed1a576bae', '67f90250a0262e085d37088f', '67e1741a43d5609350e2b608',
    '67fe7a6c9167c049fff4e37e', '67ab6ade07736060460b3c16', '6810a343264e7745556acae1',
    '6800f4c59167c049fff51f5d', '6800b8529167c049fff50e47', '6800e76e9167c049fff5197f',
    '6800ef849167c049fff51c6f', '6800fad59167c049fff52224', '680113739167c049fff52d73',
    '680106139167c049fff525af', '680125219167c049fff53405', '680957ab9167c049fff5a7c2',
    '681164d36c8fbfe5e3c91e9e', '68020ef79167c049fff54015', '68025d069167c049fff56132',
    '680b728c9167c049fff5c8f7', '680249249167c049fff55a19', '68024ed89167c049fff55b90',
    '68025b1a9167c049fff56037', '680270379167c049fff566f5', '680274c09167c049fff567c8',
    '680275419167c049fff567de', '68027b389167c049fff56954', '680291609167c049fff56cad',
    '6802a3fc9167c049fff56f5f', '6849787b17dde4ca4c4bf043', '6849435a17dde4ca4c4be251',
    '6807cb759167c049fff58dd4', '6808c3f59167c049fff599c7', '6808c3859167c049fff599b1',
    '680fa4b19167c049fff5deee', '6801e2f49167c049fff53ce1', '680a54a09167c049fff5bbc4',
    '680b94b29167c049fff5cd49', '6810df4a264e7745556ad75d', '680fa3f89167c049fff5deb1',
    '680fa844a71ddf126b77b977', '680fa9f09167c049fff5e027', '6810c9b9264e7745556acf4d',
    '681125b66c8fbfe5e3c91c62', '6818cac19e656d77bc6c72fa', '6818d27e9e656d77bc6c75a3',
    '6818dbdf9e656d77bc6c78a0', '682d97b2754f51df2ef96070', '67fccffaa0262e085d370ddc',
    '680271809167c049fff5674a'
];

const PartenairesView = () => {
    const { i18n } = useTranslation('common');
    const [searchParams] = useSearchParams();
    const [loading, setLoading] = useState(true);
    const [partenaire, setPartenaire] = useState(null);
    const [linkedProjects, setLinkedProjects] = useState([]);
    const [kvImages, setKvImages] = useState({});
    const [genericKvImages, setGenericKvImages] = useState(null);
    const [classicKvImages, setClassicKvImages] = useState(null);
    const [generatingKvs, setGeneratingKvs] = useState(false);
    const [error, setError] = useState(null);
    const [definitiveNames, setDefinitiveNames] = useState({});

    const partenaireId = searchParams.get('id');

    useEffect(() => {
        if (partenaireId) {
            fetchData();
        } else {
            setError('ID de partenaire manquant');
            setLoading(false);
        }
    }, [partenaireId]);

    const fetchData = async () => {
        try {
            setLoading(true);
            setError(null);

            // Fetch partenaire from Supabase
            const { data: partenaireData, error: partenaireError } = await supabase
                .from('fd100_partenaires')
                .select('*')
                .eq('id', partenaireId)
                .single();

            if (partenaireError || !partenaireData) {
                setError('Partenaire non trouvé');
                setLoading(false);
                return;
            }

            setPartenaire(partenaireData);

            const linkedProjectIds = partenaireData.linked_project_ids || [];
            const partenaireLogoUrl = partenaireData.logo_urls?.[0] || partenaireData.logo_url || null;

            // No linked projects — generate generic KVs only
            if (linkedProjectIds.length === 0) {
                setLinkedProjects([]);
                setLoading(false);
                if (partenaireLogoUrl) {
                    setGeneratingKvs(true);
                    try {
                        const [normalUrl, invertedUrl, classicGrayUrl, classicBlueUrl] = await Promise.all([
                            generateGenericFD100KVDataURL(partenaireData.name, partenaireLogoUrl, false),
                            generateGenericFD100KVDataURL(partenaireData.name, partenaireLogoUrl, true),
                            generateGenericFD100KVClassicDataURL(partenaireData.name, partenaireLogoUrl, false),
                            generateGenericFD100KVClassicDataURL(partenaireData.name, partenaireLogoUrl, true),
                        ]);
                        setGenericKvImages({ normal: normalUrl, inverted: invertedUrl });
                        setClassicKvImages({ normal: classicGrayUrl, inverted: classicBlueUrl });
                    } catch (err) {
                        console.error('Error generating generic KV:', err);
                    }
                    setGeneratingKvs(false);
                }
                return;
            }

            // Fetch project names and participating users in parallel
            const filteredWinnerIds = linkedProjectIds.filter(id => WINNER_PROJECT_IDS.includes(id));

            const [projectNamesResult, usersResponse] = await Promise.all([
                supabase
                    .from('fd100_project_names')
                    .select('*')
                    .eq('event_id', partenaireData.event_id),
                api.getParticipatingUsersProjectData({
                    eventId: partenaireData.event_id,
                    winnerProjectIds: filteredWinnerIds
                })
            ]);

            const namesMap = {};
            if (projectNamesResult.data) {
                projectNamesResult.data.forEach(item => {
                    namesMap[item.project_id] = {
                        name_fr: item.name_definitive_fr,
                        name_en: item.name_definitive_en,
                        designer: item.designer_definitive,
                        typology_fr: item.typology_fr,
                        typology_en: item.typology_en
                    };
                });
            }
            setDefinitiveNames(namesMap);

            let matchedProjects = [];
            usersResponse.data.forEach(user => {
                if (user.participation.data.projets) {
                    user.participation.data.projets.forEach(project_id => {
                        const project = user.company.projects.find((projet) => projet._id === project_id);
                        if (project && project.status === "validé" &&
                            WINNER_PROJECT_IDS.includes(project._id) &&
                            linkedProjectIds.includes(project._id)) {
                            if (partenaireData.type === 'fabricant' &&
                                project.communiquer_fabricants?.toLowerCase() === 'non') {
                                return;
                            }
                            matchedProjects.push({
                                project: project,
                                user: user
                            });
                        }
                    });
                }
            });

            setLinkedProjects(matchedProjects);
            // Show page content immediately, KV generation continues in background
            setLoading(false);

            // Load KV images: use frozen KVs from Supabase, fallback to parallel live generation
            if (matchedProjects.length > 0) {
                setGeneratingKvs(true);
                const projectIds = matchedProjects.map(p => p.project._id);

                const { data: frozenKvs } = await supabase
                    .from('fd100_frozen_kvs')
                    .select('project_id, version, storage_url')
                    .eq('event_id', partenaireData.event_id)
                    .in('project_id', projectIds)
                    .eq('partenaire_name', partenaireData.name);

                const frozenMap = {};
                if (frozenKvs) {
                    frozenKvs.forEach(row => {
                        if (!frozenMap[row.project_id]) frozenMap[row.project_id] = {};
                        frozenMap[row.project_id][row.version] = row.storage_url;
                    });
                }

                // Generate all KVs in parallel instead of sequentially
                const kvEntries = await Promise.all(matchedProjects.map(async (projectData) => {
                    const pid = projectData.project._id;
                    const frozen = frozenMap[pid];

                    if (frozen?.normal && frozen?.inverted) {
                        return [pid, { normal: frozen.normal, inverted: frozen.inverted }];
                    }

                    try {
                        const definitiveData = namesMap[pid];
                        const editedData = definitiveData ? {
                            projectName: definitiveData.name_fr || definitiveData.name_en,
                            creatorName: definitiveData.designer
                        } : null;

                        const [normalDataUrl, invertedDataUrl] = await Promise.all([
                            generateFD100KVDataURL({ project: projectData.project, user: projectData.user }, false, 'cover', editedData, partenaireLogoUrl, partenaireData.name),
                            generateFD100KVDataURL({ project: projectData.project, user: projectData.user }, true, 'cover', editedData, partenaireLogoUrl, partenaireData.name)
                        ]);

                        return [pid, { normal: normalDataUrl, inverted: invertedDataUrl }];
                    } catch (err) {
                        console.error(`Error generating KV for project ${pid}:`, err);
                        return null;
                    }
                }));

                const kvData = {};
                kvEntries.forEach(entry => {
                    if (entry) kvData[entry[0]] = entry[1];
                });

                setKvImages(kvData);
                setGeneratingKvs(false);
            }
        } catch (err) {
            console.error("Error fetching data:", err);
            setError('Erreur lors du chargement des données');
            setLoading(false);
        }
    };

    const downloadKV = (dataUrl, projectName, version) => {
        const link = document.createElement('a');
        link.href = dataUrl;
        link.download = `${projectName}_KeyVisual_${version}.png`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    if (loading) {
        return (
            <Section className="padding">
                <br/><br/>
                <Spinner />
            </Section>
        );
    }

    if (error) {
        return (
            <Section className="padding">
                <Container>
                    <ErrorMessage>
                        <div className="icon">&#9888;&#65039;</div>
                        <div className="title">
                            {i18n.language === 'fr' ? 'Erreur' : 'Error'}
                        </div>
                        <div className="message">{error}</div>
                    </ErrorMessage>
                </Container>
            </Section>
        );
    }

    return (
        <FD100KitPage
            mode="partenaire"
            displayName={partenaire?.name || ''}
            displayLogo={partenaire?.logo_urls?.[0] || partenaire?.logo_url || null}
            partenaireType={partenaire?.type}
            projects={linkedProjects}
            kvImages={kvImages}
            genericKvImages={genericKvImages}
            classicKvImages={classicKvImages}
            generatingKvs={generatingKvs}
            definitiveNames={definitiveNames}
            eventId={partenaire?.event_id || '67590da5499bcc995c210b40'}
            downloadKV={downloadKV}
            partenaireId={partenaireId}
        />
    );
};

export default PartenairesView;
